import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
  async getCCMConditionByPatientId (patientId) {
    const response = await _axios.get(
      `/ccmconditions/getbypatientid/${patientId}`,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM condition by patient ID');
  },
  async getCCMConditionByCCMRecordId (ccmRecordId) {
    try {
      const response = await _axios.get(
        `/ccmconditions/getbyccmrecordid/${ccmRecordId}`,
      );
      if (response.data.resFlag) {
        return response.data;
      }
      throw new CCMError('Error getting CCM condition by CCM record ID');
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return [];
      }
      throw new CCMError('Error getting CCM condition by CCM record ID', error);
    }
  },
  async getCCMCondition (id) {
    const response = await _axios.get(`/ccmconditions/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM condition');
  },
  async addCCMCondition (body) {
    const response = await _axios.post('/ccmconditions', body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error adding CCM condition');
  },
  async updateCCMCondition (id, body) {
    const response = await _axios.put(`/ccmconditions/${id}`, body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error updating CCM condition');
  },
  async deleteCCMCondition (id) {
    const response = await _axios.delete(`/ccmconditions/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error deleting CCM condition');
  },
  async editConditionHistory (id, body) {
    const response = await _axios.put(
      `/ccmconditions/editconditionhistory/${id}`,
      body,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error editing condition history');
  },
  async deleteConditionHistory (id) {
    const response = await _axios.delete(
      `/ccmconditions/deleteconditionhistory/${id}`,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error deleting condition history');
  },
};
